import { Injectable } from "@angular/core";
import { ExecutionQTestEssayGroup } from "../model/execution";
import { TranslateService } from "@ngx-translate/core";
import { VariableTypeEnum } from "../model/variable";

@Injectable()
export class QualificationUtils {
    public static getVariablesExecutionEssayByGroupJoin(group: ExecutionQTestEssayGroup, translate: TranslateService, isTempHum: boolean): string {
        let translatedValues: string[] = [];
    
        if (isTempHum) {
            translatedValues = group.essayValues
                .filter(i => i.idVariable === VariableTypeEnum.TEMPERATURE || i.idVariable === VariableTypeEnum.HUMIDITY)
                .map(i => translate.instant('variable.' + i.translationVariable));
        } else {
            translatedValues = group.essayValues
                .map(i => {
                    if (i.idVariable === VariableTypeEnum.CO2) {
                        return this.getVariableWithArticle(translate.instant('variableSub.' + i.translationVariable), translate);
                    } else {
                        return this.getVariableWithArticle((translate.instant('variable.' + i.translationVariable) as string).toLowerCase(), translate);

                    }
                });
        }
    
        translatedValues = Array.from(new Set(translatedValues));
        
        if (translatedValues.length === 1) {
            return translatedValues[0];
        }
    
        if (translatedValues.length === 2) {
            return translatedValues.join(` ${translate.instant('test.essay.y')} `);
        }
        const lastElement = translatedValues.pop();
        return `${translatedValues.join(', ')} ${translate.instant('test.essay.y')} ${lastElement}`;
    }

    public static getVariableWithArticle(data: string ,translate: TranslateService): string {
        const name = data.trim();

        const lower = name.toLowerCase();

        const isFemale =
            lower.endsWith("a") ||
            lower.endsWith("dad") ||
            lower.endsWith("tud") ||
            lower.endsWith("ción") ||
            lower.endsWith("sión") ||
            lower.includes("al") || 
            lower.includes("absor")

        if (isFemale) {
            return `${translate.instant('test.vacuumDistribution.contracted.items.la')} ${name}`;
        }
        return `${translate.instant('test.vacuumDistribution.contracted.items.el')} ${name}`;
    }
    
     public static completePhraseWithAnd(translatedValues: string[], translate: TranslateService): string {
       const conjunction = translate.instant('test.essay.y');

        if (translatedValues.length === 0) {
            return '';
        }

        if (translatedValues.length === 1) {
            return translatedValues[0];
        }

        if (translatedValues.length === 2) {
            return `${translatedValues[0]} ${conjunction} ${translatedValues[1]}`;
        }

        const allButLast = translatedValues.slice(0, -1);
        const last = translatedValues[translatedValues.length - 1];

        return `${allButLast.join(', ')} ${conjunction} ${last}`;
    }
}